export const systemConfig = {
  get isLocal(): boolean {
    return __LOCAL_DEV__ === 'true';
  },
  get environment(): string {
    return __ENV__;
  },
  get domain(): string {
    return __DOMAIN__;
  },
  get subDomain(): string {
    return __SUB_DOMAIN__;
  },
  get tenantId(): string {
    return __TENANT_ID__?.toLowerCase();
  },
  get groupName(): string {
    return __GROUP_NAME__;
  },
  get version(): string {
    return __APP_VERSION__;
  },
  get b2cLoginUrl(): string {
    return __B2C_LOGIN_URL__ ?? '';
  },
  get apiUrl(): string {
    if (__API_URL__) {
      return __API_URL__;
    }
    if (__LOCAL_DEV__ === 'true') {
      return `http://localhost:3000`;
    }
    return `https://api.${this.groupName}.${this.domain}`;
  },
  getB2CLoginUrl(): string | null {
    if (!this.b2cLoginUrl) {
      return null;
    }
    const redirectUrl = this.isLocal
      ? 'http://localhost:4203'
      : `https://${this.subDomain}.${this.domain}`;
    return `${this.b2cLoginUrl}&redirect_uri=${encodeURIComponent(redirectUrl)}`;
  },
  get configUrl(): string {
    return `https://clivconfig.${this.domain}/config/${this.tenantId}.json`;
  },
  get planConfigUrl(): string {
    return `https://clivconfig.${this.domain}/plan/${this.tenantId}.json`;
  },
  getConfigUrl(tenantId: string): string {
    return `https://clivconfig.${this.domain}/config/${tenantId.toLowerCase()}.json`;
  },
  getPlanningConfigUrl(tenantId: string): string {
    return `https://clivconfig.${this.domain}/plan/${tenantId.toLowerCase()}.json`;
  },
};
